var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breakpoint=='xs')?_c('IndexCompact',{attrs:{"customers":_vm.customers,"balances":_vm.balances,"drafts":_vm.drafts}}):_c('IndexNormal',{attrs:{"customers":_vm.customers,"balances":_vm.balances,"drafts":_vm.drafts}})}
var staticRenderFns = []

export { render, staticRenderFns }